// extracted by mini-css-extract-plugin
export var card = "_pd-0";
export var content = "_pd-2";
export var details = "_pd-3";
export var icon = "_pd-1";
export var iconBlue = "_pd-5";
export var iconBrand = "_pd-4";
export var iconGrayBlue = "_pd-6";
export var iconGreen = "_pd-7";
export var iconIndigo = "_pd-8";
export var iconOrange = "_pd-9";
export var iconPurple = "_pd-a";
export var iconRed = "_pd-b";
export var iconWarning = "_pd-c";